import {connect} from 'react-redux'

import {App} from './app.component'
import {toggleSidebar, toggleBooking} from './planner/planner.action'

import {setCommitMsg} from './socket/socket.action'


const mapStateToProps = (state) => {
    return {
        sidebarActive: state.getIn(['uiState', 'sidebarActive']),
        bookingActive: state.getIn(['uiState', 'bookingActive']),
        socketLoaded: state.getIn(['uiState', 'socketLoaded']),
        isLunaTrip: state.getIn(['lunaTrip', 'isLunaTrip'])
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onToggleSidebar: () => {
            dispatch(toggleSidebar())
        },
        onToggleBooking: () => {
            dispatch(toggleBooking())
        },
        onSetCommitMsg: (msg) => {
            dispatch(setCommitMsg(msg))
        }
    }
}

const AppContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(App)

export default AppContainer
